<div mat-dialog-content style="overflow: hidden !important;">
    <p><strong>{{data.title || 'Change Name'}}</strong></p>
    <div class="row">
        <div class="col-12">
            <mat-form-field appearance="fill">
                <input type="text" placeholder="Enter name" matInput [(ngModel)]="name">
            </mat-form-field>
        </div>
        <div class="col-12">
            <mat-checkbox labelPosition="before" color="warn" [(ngModel)]="excludeOutliers">
                Do you want to exclude outliers?
            </mat-checkbox>
        </div>
        <div class="col-12">
            <mat-checkbox labelPosition="before" color="warn" [(ngModel)]="excludeExceptions">
                Do you want to exclude exceptions?
            </mat-checkbox>
        </div>
        <div class="col-12">
            <mat-checkbox labelPosition="before" color="warn" [(ngModel)]="excludeDuplicates">
                Do you want to remove duplicates?
            </mat-checkbox>
        </div>
    </div>
</div>
<div mat-dialog-actions class="justify-content-end">
    <button mat-stroked-button color="accent" (click)="onNoClick()">Cancel</button>
    <button mat-raised-button color="accent" [disabled]="!name" (click)="onSaveClick()">Done</button>
</div>
